// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/editor","css/index"], () => (__webpack_require__("./src/js/index.js")))
__webpack_require__.O(undefined, ["css/editor","css/index"], () => (__webpack_require__("./src/css/index.css")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/editor","css/index"], () => (__webpack_require__("./src/css/editor.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
